import { LAYER_ONE, TOP_LAYER } from "constants/z-index";
import styled from "@emotion/styled";
export const StyledWhatsNewMobileFirstFoldComponent = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;

  .asset-wrapper {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    position: relative;

    .dark-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: ${TOP_LAYER};
    }

    .asset-inner {
      height: 100%;

      .picture-component {
        display: flex;
        height: 100%;
      }
    }
  }

  .content-wrapper {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    z-index: ${LAYER_ONE};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 24px;
    text-align: left;

    .core-title-container .core-title {
      font-weight: 700;
      margin-bottom: 16px;
      font-size: 2.25rem;
    }

    .paragraph-wrapper .paragraph-body {
      font-size: 1rem;
      font-weight: 500;
      line-height: 28px;
    }
  }
`;
